import React from 'react';

function Pause () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <rect width="3" height="16" x="18" y="16" fill="#fff" rx="1.5" />
      <rect width="3" height="16" x="27" y="16" fill="#fff" rx="1.5" />
      <circle cx="24" cy="24" r="23" stroke="#fff" strokeWidth="2" />
    </svg>
  );
}

export default Pause;
